import React from "react";
import { List, ListItem, ListItemText, Typography } from "@material-ui/core";
import {
  CardLoading,
  CardLoadingProps,
} from "../../../../components/card-loading";
import SimpleArtist from "../../../../../../../common/types/artist/simple-artist";
import { ArtistPlatforms } from "../../../../../../../common/types/artist/artist-platforms";

interface ArtistSummaryPlatformsProps extends CardLoadingProps {
  artist?: SimpleArtist;
}

export const ArtistSummaryPlatforms: React.FC<ArtistSummaryPlatformsProps> = ({
  artist,
  ...props
}) => {
  return (
    <CardLoading {...props} style={{ width: "200px", ...props.style }}>
      <Typography color="textSecondary" gutterBottom>
        Platforms
      </Typography>

      <List component="nav" aria-label="">
        {Object.keys(artist?.platforms || {}).map((key) => (
          <ListItem
            key={key}
            dense
            button
            component="a"
            href={
              (artist?.platforms
                ? artist.platforms[key as ArtistPlatforms]
                : "#") || "#"
            }
            target="_blank"
          >
            <ListItemText primary={key} />
          </ListItem>
        ))}
      </List>
    </CardLoading>
  );
};
